module.exports = __webpack_public_path__ + "static/hero_home_mobile-3b9202070ed3ad5c3db980ba2a9d9fe9.svg";